import React, { useCallback } from 'react'
import { useApiClient } from 'utils/api/ApiClient'
import { useFetchOne } from 'utils/api/useFetch'
import { WalletsApiClient } from 'utils/api/walletsApiClient'

import { LiveTradingAccountNavigation } from '../Navigation/LiveTradingAccountNavigation'
import { TradingAccountTab } from '../Navigation/TradingAccountNavigation'
import TradingAccountTransactionDetailsTable from './TradingAccountTransactionDetailsTable'

import '../TradingAccount.scss'

import { Pagination } from 'api/Pagination/Types/Pagination'
import { useGridState } from 'features/DataGrid'

interface Props {
  data: {
    id: string
    name: string
  }
}

const TradingAccountTransactionDetailsPage: React.FC<Props> = ({ data: tradingAccount }) => {
  const walletsApiClient = useApiClient(WalletsApiClient)
  const { gridState, gridActions } = useGridState()

  const fetchData = useCallback(() => {
    const { skip, take } = gridState
    const pagination = new Pagination({ skip, recordsPerPage: take })
    const gridQuery = { skip, pageIndex: pagination.getPageIndex(), take, pageSize: take }

    return walletsApiClient.getPlatformTransactionByTradingAccountId(tradingAccount.id, gridQuery)
  }, [tradingAccount.id, gridState.skip, gridState.take])

  const { data, isLoading } = useFetchOne(fetchData)

  return (
    <React.Fragment>
      <LiveTradingAccountNavigation
        data={tradingAccount}
        isEdit={false}
        tab={TradingAccountTab.Transactions}
      />
      <TradingAccountTransactionDetailsTable
        adjustmentTransactions={data}
        gridState={gridState}
        gridActions={gridActions}
        isLoading={isLoading}
      />
    </React.Fragment>
  )
}

export default TradingAccountTransactionDetailsPage
